export enum StatusEnum {
    PENDING, // En attente d'etre traité
    IN_PROGRESS, // En cours de traitement
    COMPLETED, // Terminé
    ERROR, // En erreur
    WAITING_RESPONSE // En attente d'une reponse du front
}